/**
 * Auto-apply system color-scheme preference to the portal root.
 *
 * Toggles the `.dark` class on <html> based on `prefers-color-scheme: dark`,
 * and stays in sync if the user changes their OS theme mid-session.
 *
 * Portal users get no theme-toggle UI by design — a customer-facing portal
 * should follow the OS rather than expose another setting. The dashboard
 * app keeps its full useTheme hook (light / dark / system + persistence)
 * because partner operators want explicit control; portal users don't.
 *
 * Returns a teardown that disconnects the media listener — main.tsx ignores
 * it (single instance for app lifetime) but tests can call it for cleanup.
 */
export function initSystemTheme(): () => void {
  if (typeof window === "undefined") return () => {};

  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const apply = (isDark: boolean) => {
    document.documentElement.classList.toggle("dark", isDark);
  };

  apply(media.matches);

  const handler = (e: MediaQueryListEvent) => apply(e.matches);
  media.addEventListener("change", handler);
  return () => media.removeEventListener("change", handler);
}
